export const DISCUSSION_ASK_TO_ANSWER = 1
export const RESPONSE_ASK_TO_REPLY = 5
